import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default (state = initialState.voucherTypesPage, action) => {
  const { filterName, filterValue, search } = action;
  switch (action.type) {
    case types.SET_VOUCHER_TYPES_PAGE:
      return {
        ...state,
        page: action.page,
      };
    case types.SET_VOUCHER_TYPES_FILTER:
      return {
        ...state,
        filters: { ...state.filters, [filterName]: filterValue },
        page: {
          ...state.page,
          number: 0,
        },
        isFiltering: true,
      };
    case types.SET_VOUCHER_TYPES_SEARCH:
      return {
        ...state,
        search,
        page: {
          ...state.page,
          number: 0,
        },
      };
    case types.CLEAR_VOUCHER_TYPES_SEARCH:
      return {
        ...state,
        search: '',
        page: {
          ...state.page,
          number: 0,
        },
      };
    case types.RESET_VOUCHER_TYPES_FILTERING:
      return {
        ...state,
        filters: initialState.voucherTypesPage.filters,
        page: {
          ...state.page,
          number: 0,
        },
        isFiltering: false,
      };
    case types.RESET_VOUCHER_TYPES_PAGE:
      return {
        ...initialState.voucherTypesPage,
      };
    default:
      return state;
  }
};
